import { reactive, watchEffect } from '@vue/composition-api';

import { Menu } from '@/types';
import { filterMenus } from '@/filemenu/utils';
import { helpDialog, modelStatisticsDialog } from './state';

const modelStatistics: Menu = {
  text: 'Model Statistics',
  click: () => { modelStatisticsDialog.value = true; },
  hotkey: 'F2',
  disabled: false,
  disallowed: [],
};

const help: Menu = {
  text: 'Help',
  click: () => { helpDialog.value = true; },
  hotkey: 'F1',
};

// Order will be preserved
const allMenus = [
  help,
  modelStatistics,
];

export const menu = reactive({
  text: 'About',
  menu_width: 180,
  menu: [] as Menu[],
});

// Enable/disable menu items based on user level
watchEffect(() => {
  // Filter allowed menus
  menu.menu = filterMenus(allMenus);
});
